import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import ShadowBox from '../common/ShadowBox'
import ShadowBoxItem from '../common/ShadowBoxItem'
import ShadowBoxTitle from '../common/ShadowBoxTitle'
import TransparentBox from '../common/TransparentBox'
import ModalEditor from './ModalEditor'
import ServiceItem from './ServiceItem'
import style from './style.module.less'
import TravelPhotography from './TravelPhotography'
import UnselectedModal from './UnselectedModal'

@inject('sessionServiceStore')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.sessionServiceStore.init()
  }

  render() {
    const store = this.props.sessionServiceStore
    const { service, activation, motivation, discard } = store
    return (
      <div
        className={style.content}
        id="sessionScrollWrapper"
        ref={ref => (this.sessionScrollWrapper = ref)}
      >
        <ShadowBox>
          <ShadowBoxTitle store={store} />
          <div className={style.main} id="sessionServiceContainer">
            {/* 旅拍目的地 */}
            <TravelPhotography />
            {service.map(
              (el, i) =>
                el.childNodes?.some(child => !child.disabled) &&
                el.isShow && (
                  <ShadowBoxItem
                    key={i + 'ShadowBoxItem'}
                    index={i}
                    {...el}
                    {...this.props}
                    maxLength={service.length}
                    onClick={() => activation(i)}
                    onMoveUp={() => motivation('up', i)}
                    onMoveDown={() => motivation('down', i)}
                    onDelete={!el.required ? () => discard(i) : null}
                  >
                    <ServiceItem data={el} store={store} />
                  </ShadowBoxItem>
                )
            )}
          </div>
        </ShadowBox>
        <TransparentBox>
          {/* <Tips /> */}
          {service.some(el => !el.isShow && el.jewelry_type != 2) && (
            <UnselectedModal store={store} />
          )}
          <ModalEditor store={store} />
        </TransparentBox>
      </div>
    )
  }
}
